var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyledActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 23.6,
    height: 23.6,
    rx: 1.8,
    fill: "#FAFAF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.2,
    width: 23.6,
    height: 23.6,
    rx: 1.8,
    stroke: "black",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 19.0578V3.93731C12.666 3.64534 13.0407 3.52541 13.2103 3.76311L21.7711 15.7666C21.8863 15.9281 21.8159 16.1549 21.6295 16.2227L13.0687 19.3397C12.873 19.4109 12.666 19.266 12.666 19.0578Z",
    stroke: "black",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 20.6281V5.50762C11.334 5.21566 10.9593 5.09572 10.7897 5.33342L2.2289 17.3369C2.11374 17.4984 2.18415 17.7252 2.3705 17.793L10.9313 20.91C11.127 20.9812 11.334 20.8363 11.334 20.6281Z",
    stroke: "black",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2093 14.9048L2.86395 17.4343C2.58778 17.518 2.5775 17.9053 2.84885 18.0035L11.1919 21.024C11.2583 21.0481 11.3311 21.0479 11.3974 21.0235L19.8133 17.932C20.0849 17.8322 20.0717 17.4436 19.794 17.3624L11.3805 14.904C11.3245 14.8876 11.265 14.8879 11.2093 14.9048Z",
    stroke: "black",
    strokeWidth: 0.35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyledActivity);
export default __webpack_public_path__ + "static/media/greyled-activity.fdeb8878a1c80eb361fbd0c8735c0466.svg";
export { ForwardRef as ReactComponent };